import { render, staticRenderFns } from "./HuellaCarbonoGeneral.vue?vue&type=template&id=6c5c4a7c&scoped=true&"
import script from "./HuellaCarbonoGeneral.vue?vue&type=script&lang=ts&"
export * from "./HuellaCarbonoGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5c4a7c",
  null
  
)

export default component.exports